/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Custom libraries
import { REG_EX } from "../constants/common";

const addressHelper = {
  validatePhoneNumber: (phoneNumber: string) => {
    const PHONE = REG_EX.PHONE;
    return (
      phoneNumber === undefined ||
      phoneNumber === null ||
      phoneNumber?.trim() === "" ||
      PHONE.test(phoneNumber?.trim())
    );
  },

  validateEmail: (email: string) => {
    const EMAIL = REG_EX.EMAIL;
    return (
      email === undefined ||
      email === null ||
      email?.trim() === "" ||
      EMAIL.test(email)
    );
  },

  canSave: (inputComment: string) => {
    return inputComment === undefined || inputComment?.trim() === "";
  },
};
export default addressHelper;
